import React, { Component } from 'react';
import ceo from './../assets/zeiseler.png';

class Team extends Component {
    render() {
        return (
          <section className="page team">
            <div id="featuredImage" className="featuredImage bgTeam"></div>
            <h1 className="title">Unser Team</h1>
            <br/>
            <div className="content">
                    <div className="teamMember">
                        <div className="headShot"><img src={ceo} alt="Dr. Dirk Zeiseler" /></div>
                        <div className="name">Dr. Dirk Zeiseler</div>
                        <div className="details">Geschäftsführer</div>
                    </div>
            </div>
          </section>
        );
    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/pages/Team.js